import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrdersComponent } from './orders.component';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { OrdersRoutingModule } from './orders-routing.module';
import { SalesOrderComponent } from './sales-order/sales-order.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { OrderOverviewComponent } from './order-overview/order-overview.component';
import { OrderInfoComponent } from './order-overview/order-info/order-info.component';
import { OrderContactsComponent } from './order-overview/order-contacts/order-contacts.component';
import { OrderPaymentsComponent } from './order-overview/order-payments/order-payments.component';
import { OrderRolesComponent } from './order-overview/order-roles/order-roles.component';
import { OrderShippingComponent } from './order-overview/order-shipping/order-shipping.component';
import { OrderItemsComponent } from './order-overview/order-items/order-items.component';
import { OrderCommunicationsComponent } from './order-overview/order-communications/order-communications.component';
import { OrderNotesComponent } from './order-overview/order-notes/order-notes.component';
import { PostalAddressComponent } from './order-overview/order-contacts/postal-address/postal-address.component';
import { EmailAddressComponent } from './order-overview/order-contacts/email-address/email-address.component';
import { TelecomNumbersComponent } from './order-overview/order-contacts/telecom-numbers/telecom-numbers.component';
import { BillingAccountsComponent } from './order-overview/order-payments/billing-accounts/billing-accounts.component';
import { FinancialAccountsComponent } from './order-overview/order-payments/financial-accounts/financial-accounts.component';
import { CreditCardComponent } from './order-overview/order-payments/credit-card/credit-card.component';
import { EftPaymentsComponent } from './order-overview/order-payments/eft-payments/eft-payments.component';
import { OfflinePaymentsComponent } from './order-overview/order-payments/offline-payments/offline-payments.component';
import { GiftCardComponent } from './order-overview/order-payments/gift-card/gift-card.component';
import { PaymentStatusesComponent } from './order-overview/order-payments/payment-statuses/payment-statuses.component';
import { ExteralPaymentsComponent } from './order-overview/order-payments/exteral-payments/exteral-payments.component';
import { NbAccordionModule } from '@nebular/theme';
import { OrderCustomerComponent } from './order-customer/order-customer.component';
import { OrderHistoryComponent } from './order-history/order-history.component';



@NgModule({
  declarations: [OrdersComponent, SalesOrderComponent, PurchaseOrderComponent, OrderOverviewComponent, OrderInfoComponent, OrderContactsComponent, OrderPaymentsComponent, OrderRolesComponent, OrderShippingComponent, OrderItemsComponent, OrderCommunicationsComponent, OrderNotesComponent, PostalAddressComponent, EmailAddressComponent, TelecomNumbersComponent, BillingAccountsComponent, FinancialAccountsComponent, CreditCardComponent, EftPaymentsComponent, OfflinePaymentsComponent, GiftCardComponent, PaymentStatusesComponent, ExteralPaymentsComponent, OrderCustomerComponent, OrderHistoryComponent],
  imports: [
    CommonModule,
    UbsViewContainersModule,
    OrdersRoutingModule,
    NbAccordionModule
  ]
})
export class OrdersModule { }
